import * as types from "./mutations-types";

export default {
    [types.SET_SESSION_LIST](state, list) {
        state.session_list = list;
    }
};
